/* K2 Sportswear - Add to Cart tracker -> n8n
   Catches every /cart/add call (Dawn product form, YMQ roster builder, Buy Now),
   reads the added line items incl. roster properties, and posts them to n8n. */
(function () {
  if (window.__k2CartTracker) return;
  window.__k2CartTracker = true;

  var WEBHOOK = 'https://YOUR-N8N-URL/webhook/k2-add-to-cart'; // <-- apna n8n URL
  var origFetch = window.fetch.bind(window);
  var lastKey = '';
  var lastTime = 0;

  function isAddUrl(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }

  function send(payload) {
    var body = JSON.stringify(payload);
    try {
      origFetch(WEBHOOK, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: body.length < 60000 // Buy Now redirect pe bhi request na kate
      }).catch(function () {});
    } catch (e) {}
  }

  function handle(data) {
    if (!data || data.status) return; // Shopify error response
    var items = Array.isArray(data.items) ? data.items : data.id ? [data] : [];
    if (!items.length) return;

    // Double event se bachao (same items 3 sec ke andar)
    var key = items.map(function (i) { return i.key + ':' + i.quantity; }).join('|');
    if (key === lastKey && Date.now() - lastTime < 3000) return;
    lastKey = key;
    lastTime = Date.now();

    var clean = items.map(function (it) {
      return {
        product: it.product_title,
        variant: it.variant_title,
        variant_id: it.variant_id,
        sku: it.sku,
        quantity: it.quantity,
        price: (it.final_price || it.price || 0) / 100,
        url: it.url ? location.origin + it.url : null,
        image: it.image || null,
        properties: it.properties || {} // YMQ roster: names, numbers, sizes, file URL
      };
    });

    origFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .then(function (cart) {
        send({
          event: 'add_to_cart',
          items: clean,
          cart: cart
            ? {
                token: cart.token,
                item_count: cart.item_count,
                total: cart.total_price / 100,
                currency: cart.currency
              }
            : null,
          customer: window.K2_CUSTOMER || null,
          page: location.href,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent,
          time: new Date().toISOString()
        });
      });
  }

  // fetch() wale add-to-cart (Dawn product-form, YMQ new versions)
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (isAddUrl(url)) {
      p.then(function (res) {
        if (res.ok) res.clone().json().then(handle).catch(function () {});
      }).catch(function () {});
    }
    return p;
  };

  // XMLHttpRequest / jQuery.ajax wale add-to-cart (kuch apps abhi bhi yehi use karti hain)
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__k2Url = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (isAddUrl(xhr.__k2Url)) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try { handle(JSON.parse(xhr.responseText)); } catch (e) {}
        }
      });
    }
    return origSend.apply(this, arguments);
  };
})();